module.exports = __webpack_public_path__ + "img/PL09288.671d6cab.png";